import React, { Component } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Calendar, User, Share2, ArrowRight } from 'lucide-react';
interface ArticlePageProps {
  title: string;
  excerpt: string;
  content: React.ReactNode;
  author: {
    name: string;
    image: string;
    id: string;
  };
  date: string;
  category: string;
  image: string;
  relatedArticles?: Array<{
    id: number;
    title: string;
    excerpt: string;
    image: string;
    category: string;
  }>;
}
export function ArticlePage({
  title,
  excerpt,
  content,
  author,
  date,
  category,
  image,
  relatedArticles = []
}: ArticlePageProps) {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-86" data-mp="185d6mlyik3gl">
      <Header data-id="element-87" data-mp="1d3wu4qsr9nb2" />
      <main className="flex-grow" data-id="element-88" data-mp="1d2lr4t74wjl0">
        {/* Hero Section */}
        <section className="relative w-full bg-navy-50" data-id="element-89" data-mp="39w6ppj7pn2tc">
          <div className="absolute inset-0 overflow-hidden" data-id="element-90" data-mp="39xrmlfhhyxud">
            <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
            backgroundImage: `url('${image}')`,
            backgroundBlendMode: 'overlay'
          }} data-id="element-91" data-mp="3eu8b4aslze7z" />
            <div className="absolute inset-0 bg-gradient-to-r from-teal-600/20 to-navy-600/20" data-id="element-92" data-mp="2c3us8ec6m8o6" />
          </div>
          <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-93" data-mp="281zs3d5zm1bz">
            <div className="max-w-3xl mx-auto" data-id="element-94" data-mp="2373y47h6x3w8">
              <div className="flex items-center text-sm text-navy-500 mb-4" data-id="element-95" data-mp="2zw1tnrwrl5ug">
                <span className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-medium" data-id="element-96" data-mp="2vtygmyug5t72">
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </span>
                <span className="mx-2" data-id="element-97" data-mp="2lvr2enrjlp8r">•</span>
                <Calendar size={16} className="mr-1" data-id="element-98" data-mp="2luz5n9m7llgw" />
                <span data-id="element-99" data-mp="1ffopxy2qfsd2">{date}</span>
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-navy-800 mb-4" data-id="element-100" data-mp="1fh9mtucirne3">
                {title}
              </h1>
              <p className="text-lg text-navy-700 mb-6" data-id="element-101" data-mp="1aiok9o9sormh">{excerpt}</p>
              <div className="flex items-center" data-id="element-102" data-mp="1bz2cohxxk0r0">
                <a href={`/authors/${author.id}`} className="flex items-center group" data-id="element-103" data-mp="1gwltnpm0irmn">
                  <img src={author.image} alt={author.name} className="w-10 h-10 rounded-full mr-3 object-cover" data-id="element-104" data-mp="12wb02etbiyxs" />
                  <span className="text-navy-700 group-hover:text-teal-600 transition-colors duration-200" data-id="element-105" data-mp="t6890k5rbv23">
                    By {author.name}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Article Content */}
        <section className="py-12" data-id="element-106" data-mp="o7eyn0lrok65">
          <div className="container mx-auto px-4" data-id="element-107" data-mp="o8g6kw7hkqjn">
            <div className="max-w-3xl mx-auto" data-id="element-108" data-mp="a7vraa0s5cuw">
              <div className="mb-10" data-id="element-109" data-mp="a970wqgwpetx">
                <img src={image} alt={title} className="w-full h-auto rounded-lg mb-8" data-id="element-110" data-mp="f78j796ida4c" />
                {/* Article content */}
                <div className="prose prose-lg max-w-none text-navy-700" data-id="element-111" data-mp="3ms9kx55xfg1d">
                  {content}
                </div>
              </div>
              {/* Share Section */}
              <div className="border-t border-b border-navy-200 py-6 my-8" data-id="element-112" data-mp="5hjlv75zjfjs">
                <div className="flex items-center justify-between" data-id="element-113" data-mp="ji18hswv867">
                  <div className="flex items-center" data-id="element-114" data-mp="ejj3a0kwwln9">
                    <Share2 size={20} className="text-navy-600 mr-2" data-id="element-115" data-mp="9lhjfdfnwiaq" />
                    <span className="text-navy-700 font-medium" data-id="element-116" data-mp="9l7snnmsm73z">
                      Share this article
                    </span>
                  </div>
                  <div className="flex space-x-4" data-id="element-117" data-mp="jb11whzgqa52">
                    <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noopener noreferrer" className="text-navy-600 hover:text-teal-600 transition-colors" aria-label="Share on Twitter" data-id="element-118" data-mp="jddsfjjadstq">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-119" data-mp="2wi0pojl82nn9">
                        <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" data-id="element-120" data-mp="2dqg96fyd65q7"></path>
                      </svg>
                    </a>
                    <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noopener noreferrer" className="text-navy-600 hover:text-teal-600 transition-colors" aria-label="Share on Facebook" data-id="element-121" data-mp="3p6eo30g83lzc">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-122" data-mp="18r1j0iluu9a0">
                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-123" data-mp="kunh1k7ptlpr"></path>
                      </svg>
                    </a>
                    <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noopener noreferrer" className="text-navy-600 hover:text-teal-600 transition-colors" aria-label="Share on LinkedIn" data-id="element-124" data-mp="2k79ek02vckc6">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-125" data-mp="2pe6ezq7wzimg">
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-126" data-mp="3d27hahei22tf"></path>
                        <rect x="2" y="9" width="4" height="12" data-id="element-127" data-mp="1wnemb2q25c3v"></rect>
                        <circle cx="4" cy="4" r="2" data-id="element-128" data-mp="1wqakms5ti2su"></circle>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              {/* Author Section */}
              <div className="bg-navy-50 p-6 rounded-lg mb-12" data-id="element-129" data-mp="1p4f2ivyopijz">
                <div className="flex items-start" data-id="element-130" data-mp="1p45evf143nhg">
                  <img src={author.image} alt={author.name} className="w-16 h-16 rounded-full mr-4 object-cover" data-id="element-131" data-mp="234pu617tj167" />
                  <div data-id="element-132" data-mp="1af0txq2xn55n">
                    <h3 className="text-lg font-bold text-navy-800 mb-1" data-id="element-133" data-mp="1agk8nc8xx85b">
                      About {author.name}
                    </h3>
                    <p className="text-navy-600 mb-2" data-id="element-134" data-mp="16c46nm2g6kvd">
                      Microbiome scientist with over 5 years of experience in
                      pharmaceutical research
                    </p>
                    <a href={`/authors/${author.id}`} className="text-teal-600 hover:text-teal-700 font-medium flex items-center text-sm" data-id="element-135" data-mp="1fcsjwek0oh77">
                      View profile
                      <ArrowRight size={14} className="ml-1" data-id="element-136" data-mp="24we1es03q1g" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Related Articles */}
        {relatedArticles.length > 0 && <section className="py-12 bg-navy-50" data-id="element-137" data-mp="g3m9yr333jo8">
            <div className="container mx-auto px-4" data-id="element-138" data-mp="g5gw28q3dhtw">
              <div className="max-w-5xl mx-auto" data-id="element-139" data-mp="l38kutvfwntv">
                <h2 className="text-2xl font-bold text-navy-800 mb-8" data-id="element-140" data-mp="l2gzsczgy8hu">
                  Related Articles
                </h2>
                <div className="grid md:grid-cols-3 gap-6" data-id="element-141" data-mp="p27pedd9eiks">
                  {relatedArticles.map(article => <div key={article.id} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-142" data-mp="yu3yejgvvt3s">
                      <div className="h-40 overflow-hidden" data-id="element-143" data-mp="18s1jiy3g59s6">
                        <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" data-id="element-144" data-mp="18q6zrn3wvnpo" />
                      </div>
                      <div className="p-5" data-id="element-145" data-mp="2jeikorsgee4p">
                        <div className="mb-2" data-id="element-146" data-mp="2eduxyib9cjga">
                          <span className="bg-teal-100 text-teal-800 px-2 py-1 rounded-full text-xs font-medium" data-id="element-147" data-mp="2ef5x24trd312">
                            {article.category.charAt(0).toUpperCase() + article.category.slice(1)}
                          </span>
                        </div>
                        <h3 className="text-lg font-bold text-navy-800 mb-2" data-id="element-148" data-mp="3297c0bna8q1e">
                          {article.title}
                        </h3>
                        <p className="text-navy-600 text-sm mb-3 line-clamp-2" data-id="element-149" data-mp="3ururnbjifcv3">
                          {article.excerpt}
                        </p>
                        <a href={`/blog/${article.id}`} className="text-teal-600 hover:text-teal-700 font-medium flex items-center text-sm" data-id="element-150" data-mp="3pyrwiyz33vcs">
                          Read more
                          <ArrowRight size={14} className="ml-1" data-id="element-151" data-mp="39wwurg7vt30f" />
                        </a>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </section>}
      </main>
      <Footer data-id="element-152" data-mp="3euyd1yxhgyau" />
    </div>;
}